/**
 * Below the collapse point every column hides and the row grows a single meta
 * line carrying what they held. Nothing is lossy at any width, which is why
 * there is one collapse point rather than per-column hiding.
 */
export function composeMetaLine(
  parts: readonly (string | null | undefined)[]
): string {
  return parts
    .filter(
      (part): part is string =>
        typeof part === 'string' && part.trim().length > 0
    )
    .map(part => part.trim())
    .join(' · ');
}
